import React from 'react'
import styled from 'styled-components'
import TreeSelect from 'components/TreeSelect'
import { Col } from 'antd'
import FormItem from 'antd/es/form/FormItem'

const FilterLabel = styled.p`
  color: ${({ color }) => color || '#4D566E'};
  font-size: 14px;
  font-weight: 600;
  white-space: ${({ whiteSpace }) => whiteSpace || 'normal'};
`

const StyledCol = styled(Col)`
  display: flex;
  flex-direction: ${({ direction }) => direction || 'column'};
  align-items: flex-start;
`

const TreeFilter = ({
  span = 23,
  width = '100%',
  label,
  placeholder,
  treeData,
  value,
  onChange,
  onSearch,
  onDropdownClose, // <-- add this prop
  disabled = false,
  direction = 'column',
  valueKey,
  labelColor = '4D566E', // new prop
  maxSelectedCount,
}) => {
  const processedTreeData = Array.isArray(treeData)
    ? Array.from(
        new Map(
          treeData
            // Drop entries with no usable value (e.g. an empty-string function/
            // role from the backend) so they don't render as a blank checkbox.
            .filter(item => {
              const value = item?.value ?? item?.id ?? item?.name
              return (
                value !== undefined &&
                value !== null &&
                String(value).trim() !== ''
              )
            })
            .map(item => {
              const value = item.value ?? item.id ?? item.name
              return [value, {
                ...item,
                title: item.name ?? item.value,
                value: value,
              }]
            })
        ).values()
      )
    : []
  const handleChange = (val) => {
    // Enforce selection cap when provided. TreeSelect (checkable) returns an array.
    let nextVal = val
    if (typeof maxSelectedCount === 'number' && Array.isArray(val)) {
      if (maxSelectedCount <= 0) {
        nextVal = []
      } else if (val.length > maxSelectedCount) {
        // keep the most recently selected item(s); assume last entries are latest
        nextVal = val.slice(-maxSelectedCount)
      }
    }
    onChange(nextVal, valueKey)
  }
  return (
    <StyledCol span={span} direction={direction} id="id">
      <FilterLabel color={labelColor}>{label}</FilterLabel>
      <FormItem style={{ width }} className="tree-select-degree">
        <TreeSelect
          showArrow
          filterTreeNode={false}
          treeCheckable
          placeholder={placeholder}
          maxTagCount={0}
          showSearch
          treeDefaultExpandAll
          removeTreeIndent
          shadowBox
          onChange={handleChange}
          onSearch={val => onSearch?.(val, valueKey)}
          treeData={processedTreeData}
          value={value || []}
          height="auto"
          treeNodeFilterProp="name"
          autoClearSearchValue={false}
          disabled={disabled}
          getPopupContainer={triggerNode => triggerNode.parentNode}
          onDropdownVisibleChange={open => {
            if (!open && typeof onDropdownClose === 'function') {
              onDropdownClose()
            }
          }}
        />
      </FormItem>
    </StyledCol>
  )
}

export default TreeFilter
